module.exports = __webpack_public_path__ + "img/37.dda8df3a.jpg";